.wrapper {
  color: var(--dds-color-text-requiredfield);
}
